import React from 'react';
import Icon from '../../../components/AppIcon';

const ApprovalConfirmation = ({ decision, ticketNumber, customerName, orgName }) => {
  const isApproved = decision === 'approved';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Success/Rejection Card */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          {/* Top Banner */}
          <div className={`px-8 py-10 text-center ${
            isApproved
              ? 'bg-gradient-to-br from-emerald-500 to-teal-600' :'bg-gradient-to-br from-red-500 to-rose-600'
          }`}>
            <div className={`w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4 ${
              isApproved ? 'bg-white/20' : 'bg-white/20'
            }`}>
              <Icon
                name={isApproved ? 'CheckCircle2' : 'XCircle'}
                size={44}
                color="white"
              />
            </div>
            <h1 className="text-2xl font-bold text-white mb-2">
              {isApproved ? 'Service Approved!' : 'Service Rejected'}
            </h1>
            <p className="text-white/85 text-sm">
              {isApproved
                ? 'Thank you for approving the service request.'
                : 'Your rejection has been recorded.'}
            </p>
          </div>

          {/* Details */}
          <div className="px-8 py-6">
            <div className="space-y-3 mb-6">
              <div className="flex items-center justify-between py-2.5 border-b border-gray-100">
                <span className="text-sm text-gray-500">Ticket Number</span>
                <span className="text-sm font-semibold text-gray-900 font-mono">{ticketNumber}</span>
              </div>
              <div className="flex items-center justify-between py-2.5 border-b border-gray-100">
                <span className="text-sm text-gray-500">Decision</span>
                <span className={`text-sm font-bold uppercase ${
                  isApproved ? 'text-emerald-600' : 'text-red-600'
                }`}>{decision}</span>
              </div>
              <div className="flex items-center justify-between py-2.5">
                <span className="text-sm text-gray-500">Submitted By</span>
                <span className="text-sm font-medium text-gray-900">{customerName}</span>
              </div>
            </div>

            {/* Next Steps */}
            <div className={`rounded-xl p-4 ${
              isApproved ? 'bg-emerald-50 border border-emerald-100' : 'bg-gray-50 border border-gray-100'
            }`}>
              <p className={`text-xs font-semibold uppercase tracking-wide mb-3 ${
                isApproved ? 'text-emerald-700' : 'text-gray-600'
              }`}>What happens next</p>
              {isApproved ? (
                <ul className="space-y-2">
                  {[
                    'The service team has been notified of your approval',
                    'A technician will be scheduled for your service',
                    'You will receive a confirmation with appointment details'
                  ]?.map((step, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <div className="w-5 h-5 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Icon name="Check" size={11} color="#059669" />
                      </div>
                      <span className="text-sm text-gray-700">{step}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <ul className="space-y-2">
                  {[
                    'The service team has been notified of your decision',
                    'A representative will contact you to discuss your concerns',
                    'You can request a revised service proposal'
                  ]?.map((step, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <div className="w-5 h-5 bg-gray-200 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Icon name="ArrowRight" size={11} color="#6b7280" />
                      </div>
                      <span className="text-sm text-gray-700">{step}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <p className="text-xs text-gray-400 text-center mt-5">
              Powered by {orgName || 'FieldServicePro'} &bull; Response recorded at {new Date()?.toLocaleString()}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalConfirmation;
